import React from "react";
import { Typography } from "@mui/material";

interface ParagraphTextProps {
  children: React.ReactNode;
}

const ParagraphList: React.FC<ParagraphTextProps> = ({ children }) => {
  return (
    <Typography
      variant="h6"
      gutterBottom
      align="center"
      sx={{
        lineHeight: "1.8",
        color: "grey",
        fontWeight: 400,
      }}
    >
      {children}
    </Typography>
  );
};

export default ParagraphList;
